// removes type script error when trying to access window.EXCLUDE_DATES
declare global {
  interface Window {
    EXCLUDE_DATES: string[];
  }
}

// Format estimatedDispatchDate to be in the format: X day, Xth X month
const nthNumber = (number: number) => {
  if (number > 3 && number < 21) return 'th'
  switch (number % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

const isExcludeDate = (currentDate: Date) => {
  const EXCLUDE_DATES = window.EXCLUDE_DATES
  const dataExcludeDates = EXCLUDE_DATES.map((date: string) => date.trim()).filter((date: string) => date)
  if (!dataExcludeDates.length) {
    return false
  }
  return dataExcludeDates.some((date: string) => date === currentDate.toLocaleDateString("en-GB", { month: '2-digit', day: '2-digit' }))
}

// Add number of businesss day (numberOfBusinessDays) to todays date (currentDate) and account for weekends
// CDSD-27910 logic copied over from business-date-inherits.js
export const addBusinessDays = (date: Date, days: number) => {
  const currentDate = new Date(date.valueOf())
  let isExclude = false

  for (let i = 1; i <= days; i++) {
    if (days === 1) {
      if(!isExclude) currentDate.setDate(currentDate.getDate() + 1);

      if(isExcludeDate(currentDate)) isExclude = false

      if (currentDate.getDay() === 6) {
        currentDate.setDate(currentDate.getDate() + 2);
      } else if (currentDate.getDay() === 0) {
        currentDate.setDate(currentDate.getDate() + 1);
      }
      if (isExcludeDate(currentDate)) {
        i--;
        isExclude = true
        currentDate.setDate(currentDate.getDate() + 1);
      }
    } else {
      currentDate.setDate(currentDate.getDate() + 1);
      if (currentDate.getDay() === 6) {
        currentDate.setDate(currentDate.getDate() + 2);
      } else if (currentDate.getDay() === 0) {
        currentDate.setDate(currentDate.getDate() + 1);
      }
      if (isExcludeDate(currentDate)) {
        i--;
      }
    }
  }

  return currentDate
}

export const formatDate = (date: Date) => {
  const weekday = date.toLocaleString('default', { weekday: 'long' })
  const day = date.getDate()
  const month = date.toLocaleString('default', { month: 'long' })
  return `${weekday}, ${day}${nthNumber(day)} ${month}`
}
